export const ModalNames = {
  RemoveScenarioDetail: 'RemoveScenarioDetail',
};

export const DEFAULT_ACCOUNT = 'STMAUNALOC';

export const NoDetailValue = 'N/A';
